import { useRouterState } from '@tanstack/react-router'
import { useMemo } from 'react'
import { last } from 'remeda'

export function useReturnTo() {
  const route = useRouterState({ select: (s) => last(s.matches) })
  const returnTo = useMemo(() => {
    return route
      ? {
          to: route.fullPath,
          params: route.params,
          search: route.search,
        }
      : undefined
  }, [route?.fullPath, route?.params, route?.search])

  return returnTo
}
